import { useHistory } from 'react-router'
import { useGateValue } from '@statsig/react-bindings'

import { useService } from 'services'
import { useDispatch, useSelector, resetState } from 'stores'
import { analyticsInstance } from 'lib/events'
import { analyticsMerchant, analyticsSupplier } from 'modules/analytics'
import { FeatureFlagValue } from '@types'
import { EventNames, Scopes } from 'constants/events/mixpanel'
import { REACT_APP_ENABLE_V2_SIGN_OUT } from 'constants/envs'
import { URL_HOME } from 'constants/urls'

export function useLogout() {
  const { auth: service } = useService()
  const history = useHistory()
  const dispatch = useDispatch()
  const userRoles = useSelector(
    (state) => state.user.detail.data.currentCompany
  )
  const isNewXpEnabled = useGateValue(FeatureFlagValue.NEW_EXPERIENCE)

  const logout = async () => {
    try {
      if (REACT_APP_ENABLE_V2_SIGN_OUT) {
        const { uid } = service.getCurrentUser() ?? {}

        if (!uid) return

        await fetch('/api/auth/revoke-tokens', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uid }),
        })
      }
    } finally {
      const eventName = `${Scopes.Account}__${EventNames.LoggedOut}`
      const { is_buyer, is_salesperson, is_seller } = userRoles ?? {}

      // Logout from new xp
      if (isNewXpEnabled) {
        analyticsInstance.track(eventName)
        analyticsInstance.reset()
      } else {
        // Logout from merchant
        if (is_buyer) {
          analyticsMerchant.track(eventName)
          analyticsMerchant.reset()
        }

        // Logout from supplier and salesperson
        if (is_salesperson || is_seller) {
          analyticsSupplier.track(eventName)
          analyticsSupplier.reset()
        }
      }

      dispatch(resetState())
      service.signOut()

      history?.push(URL_HOME)
    }
  }

  return { logout }
}
